// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration FOR PRODUCTION
// Browser API key from env (set REACT_APP_FIREBASE_API_KEY locally + GitHub secret REACT_APP_FIREBASE_API_KEY_PRD in CI)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "roto-gpt-prod-zyx.firebaseapp.com",
  projectId: "roto-gpt-prod-zyx",
  storageBucket: "roto-gpt-prod-zyx.firebasestorage.app",
  messagingSenderId: "239336403924",
  appId: "1:239336403924:web:af93f764d10d441dca9c41",
  measurementId: "G-Y7WVH85Q8J",
};

// DEV TEST
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: "roto-gpt-dev-zyx.firebaseapp.com",
//   projectId: "roto-gpt-dev-zyx",
//   storageBucket: "roto-gpt-dev-zyx.firebasestorage.app",
//   messagingSenderId: "430213956133",
//   appId: "1:430213956133:web:0f7f5ea60c9ba8fc15b5cc",
//   measurementId: "G-LYVDYVLPC1",
// };

// Initialize Firebase App Core
const app = initializeApp(firebaseConfig);

// Define the production URL
const prodBackendUrl = "https://chat-backend.rotogpt.com";
// Check if the current environment is a production environment
const isProdEnvironment = process.env.REACT_APP_BACKEND_URL === prodBackendUrl;

let analytics;

// Only initialize Analytics in production, or when explicitly forced for local DEV testing.
const forceEnabled = process.env.REACT_APP_ANALYTICS_FORCE_ENABLED === "true";
if (isProdEnvironment || forceEnabled) {
  analytics = getAnalytics(app);
  console.log(`[Analytics] Firebase Analytics initialized (${isProdEnvironment ? "PRODUCTION" : "FORCE DEV"}).`);
} else {
  console.log("[Analytics] Firebase Analytics SKIPPED for non-production environment.");
}

// Export the variable (that will be `undefined` in dev)
export { analytics };
